"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var enclosed = _a.enclosed;
            return ({
                marginTop: enclosed ? 0 : 8,
                marginBottom: enclosed ? 0 : 4,
                '& .MuiInputBase-root': {
                    borderRadius: 8,
                    '&::after, &::before ': { display: enclosed ? 'none' : 'block' },
                },
                '& .MuiFilledInput-input': {
                    padding: enclosed ? '10px 0 8px 8px' : '23px 12px 8px 4px',
                },
                '& .MuiFormHelperText-root': {
                    top: enclosed ? 'calc(50% - 14px)' : 'initial',
                    right: enclosed ? 0 : 'initial',
                },
            });
        },
        textLength: function (_a) {
            var error = _a.error;
            return ({
                color: error ? theme.palette.error.main : 'inherit',
                display: 'flex',
                justifyContent: 'space-between',
            });
        },
        endAdornment: function (_a) {
            var error = _a.error;
            return ({
                fontSize: '12px',
                color: error ? theme.palette.error.main : 'inherit',
                weight: error ? 'bold' : 'regular',
            });
        },
    });
});
